import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { SymbolKind } from 'vscode-languageserver-types';
import { Kind, parse, print } from 'graphql';
import { getAutocompleteSuggestions } from './getAutocompleteSuggestions';
import { getHoverInformation } from './getHoverInformation';
import { validateQuery, getRange, DIAGNOSTIC_SEVERITY } from './getDiagnostics';
import { getDefinitionQueryResultForFragmentSpread, getDefinitionQueryResultForDefinitionNode, getDefinitionQueryResultForNamedType } from './getDefinition';
import { getOutline } from './getOutline';
import { getASTNodeAtPosition } from 'graphql-language-service-utils';
const FRAGMENT_DEFINITION = Kind.FRAGMENT_DEFINITION,
      OBJECT_TYPE_DEFINITION = Kind.OBJECT_TYPE_DEFINITION,
      INTERFACE_TYPE_DEFINITION = Kind.INTERFACE_TYPE_DEFINITION,
      ENUM_TYPE_DEFINITION = Kind.ENUM_TYPE_DEFINITION,
      UNION_TYPE_DEFINITION = Kind.UNION_TYPE_DEFINITION,
      SCALAR_TYPE_DEFINITION = Kind.SCALAR_TYPE_DEFINITION,
      INPUT_OBJECT_TYPE_DEFINITION = Kind.INPUT_OBJECT_TYPE_DEFINITION,
      SCALAR_TYPE_EXTENSION = Kind.SCALAR_TYPE_EXTENSION,
      OBJECT_TYPE_EXTENSION = Kind.OBJECT_TYPE_EXTENSION,
      INTERFACE_TYPE_EXTENSION = Kind.INTERFACE_TYPE_EXTENSION,
      UNION_TYPE_EXTENSION = Kind.UNION_TYPE_EXTENSION,
      ENUM_TYPE_EXTENSION = Kind.ENUM_TYPE_EXTENSION,
      INPUT_OBJECT_TYPE_EXTENSION = Kind.INPUT_OBJECT_TYPE_EXTENSION,
      DIRECTIVE_DEFINITION = Kind.DIRECTIVE_DEFINITION,
      FRAGMENT_SPREAD = Kind.FRAGMENT_SPREAD,
      OPERATION_DEFINITION = Kind.OPERATION_DEFINITION,
      NAMED_TYPE = Kind.NAMED_TYPE;
const KIND_TO_SYMBOL_KIND = {
  [Kind.FIELD]: SymbolKind.Field,
  [Kind.OPERATION_DEFINITION]: SymbolKind.Class,
  [Kind.FRAGMENT_DEFINITION]: SymbolKind.Class,
  [Kind.FRAGMENT_SPREAD]: SymbolKind.Struct,
  [Kind.OBJECT_TYPE_DEFINITION]: SymbolKind.Class,
  [Kind.ENUM_TYPE_DEFINITION]: SymbolKind.Enum,
  [Kind.ENUM_VALUE_DEFINITION]: SymbolKind.EnumMember,
  [Kind.INPUT_OBJECT_TYPE_DEFINITION]: SymbolKind.Class,
  [Kind.INPUT_VALUE_DEFINITION]: SymbolKind.Field,
  [Kind.FIELD_DEFINITION]: SymbolKind.Field,
  [Kind.INTERFACE_TYPE_DEFINITION]: SymbolKind.Interface,
  [Kind.DOCUMENT]: SymbolKind.File,
  FieldWithArguments: SymbolKind.Method
};

function getKind(tree) {
  if (tree.kind === 'FieldDefinition' && tree.children && tree.children.length > 0) {
    return KIND_TO_SYMBOL_KIND.FieldWithArguments;
  }

  return KIND_TO_SYMBOL_KIND[tree.kind];
}

export class GraphQLLanguageService {
  constructor(cache) {
    this._graphQLCache = cache;
    this._graphQLConfig = cache.getGraphQLConfig();
  }

  getConfigForURI(uri) {
    const config = this._graphQLCache.getProjectForFile(uri);

    if (config) {
      return config;
    }

    throw Error("No config found for uri: ".concat(uri));
  }

  getDiagnostics(query, uri, isRelayCompatMode) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var queryHasExtensions, projectConfig, schemaPath, projectName, extensions, queryAST, range, source, fragmentDefinitions, fragmentDependencies, dependenciesSource, validationAst, customRules, schema;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            queryHasExtensions = false;
            projectConfig = this.getConfigForURI(uri);

            if (projectConfig) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", []);

          case 4:
            schemaPath = projectConfig.schema, projectName = projectConfig.name, extensions = projectConfig.extensions;
            _context.prev = 5;
            queryAST = parse(query);

            if (!schemaPath || uri !== schemaPath) {
              queryHasExtensions = queryAST.definitions.some(definition => {
                switch (definition.kind) {
                  case OBJECT_TYPE_DEFINITION:
                  case INTERFACE_TYPE_DEFINITION:
                  case ENUM_TYPE_DEFINITION:
                  case UNION_TYPE_DEFINITION:
                  case SCALAR_TYPE_DEFINITION:
                  case INPUT_OBJECT_TYPE_DEFINITION:
                  case SCALAR_TYPE_EXTENSION:
                  case OBJECT_TYPE_EXTENSION:
                  case INTERFACE_TYPE_EXTENSION:
                  case UNION_TYPE_EXTENSION:
                  case ENUM_TYPE_EXTENSION:
                  case INPUT_OBJECT_TYPE_EXTENSION:
                  case DIRECTIVE_DEFINITION:
                    return true;
                }

                return false;
              });
            }

            _context.next = 14;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](5);
            range = getRange(_context.t0.locations[0], query);
            return _context.abrupt("return", [{
              severity: DIAGNOSTIC_SEVERITY.Error,
              message: _context.t0.message,
              source: 'GraphQL: Syntax',
              range
            }]);

          case 14:
            source = query;
            _context.next = 17;
            return this._graphQLCache.getFragmentDefinitions(projectConfig);

          case 17:
            fragmentDefinitions = _context.sent;
            _context.next = 20;
            return this._graphQLCache.getFragmentDependencies(query, fragmentDefinitions);

          case 20:
            fragmentDependencies = _context.sent;
            dependenciesSource = fragmentDependencies.reduce((prev, cur) => "".concat(prev, " ").concat(print(cur.definition)), '');
            source = "".concat(source, " ").concat(dependenciesSource);
            validationAst = null;
            _context.prev = 24;
            validationAst = parse(source);
            _context.next = 31;
            break;

          case 28:
            _context.prev = 28;
            _context.t1 = _context["catch"](24);
            return _context.abrupt("return", []);

          case 31:
            customRules = null;

            if ((extensions === null || extensions === void 0 ? void 0 : extensions.customValidationRules) && typeof extensions.customValidationRules === 'function') {
              customRules = extensions.customValidationRules(this._graphQLConfig);
            }

            _context.next = 35;
            return this._graphQLCache.getSchema(projectName, queryHasExtensions);

          case 35:
            schema = _context.sent;

            if (schema) {
              _context.next = 38;
              break;
            }

            return _context.abrupt("return", []);

          case 38:
            return _context.abrupt("return", validateQuery(validationAst, schema, customRules, isRelayCompatMode));

          case 39:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[5, 10], [24, 28]]);
    }));
  }

  getAutocompleteSuggestions(query, position, filePath) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var projectConfig, schema, fragmentDefinitions, fragmentInfo;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            projectConfig = this.getConfigForURI(filePath);
            _context2.next = 3;
            return this._graphQLCache.getSchema(projectConfig.name);

          case 3:
            schema = _context2.sent;
            _context2.next = 6;
            return this._graphQLCache.getFragmentDefinitions(projectConfig);

          case 6:
            fragmentDefinitions = _context2.sent;
            fragmentInfo = Array.from(fragmentDefinitions).map(([, info]) => info.definition);

            if (!schema) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", getAutocompleteSuggestions(schema, query, position, undefined, fragmentInfo));

          case 10:
            return _context2.abrupt("return", []);

          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
  }

  getHoverInformation(query, position, filePath) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var projectConfig, schema;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            projectConfig = this.getConfigForURI(filePath);
            _context3.next = 3;
            return this._graphQLCache.getSchema(projectConfig.name);

          case 3:
            schema = _context3.sent;

            if (!schema) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", getHoverInformation(schema, query, position));

          case 6:
            return _context3.abrupt("return", '');

          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
  }

  getDefinition(query, position, filePath) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var projectConfig, ast, node;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            projectConfig = this.getConfigForURI(filePath);
            _context4.prev = 1;
            ast = parse(query);
            _context4.next = 8;
            break;

          case 5:
            _context4.prev = 5;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", null);

          case 8:
            node = getASTNodeAtPosition(query, ast, position);

            if (!node) {
              _context4.next = 16;
              break;
            }

            _context4.t1 = node.kind;
            _context4.next = _context4.t1 === FRAGMENT_SPREAD ? 13 : _context4.t1 === FRAGMENT_DEFINITION ? 14 : _context4.t1 === OPERATION_DEFINITION ? 14 : _context4.t1 === NAMED_TYPE ? 15 : 16;
            break;

          case 13:
            return _context4.abrupt("return", this._getDefinitionForFragmentSpread(query, ast, node, filePath, projectConfig));

          case 14:
            return _context4.abrupt("return", getDefinitionQueryResultForDefinitionNode(filePath, query, node));

          case 15:
            return _context4.abrupt("return", this._getDefinitionForNamedType(query, ast, node, filePath, projectConfig));

          case 16:
            return _context4.abrupt("return", null);

          case 17:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this, [[1, 5]]);
    }));
  }

  getDocumentSymbols(document, filePath) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var outline, output, input, res, _res, parent, tree;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return this.getOutline(document);

          case 2:
            outline = _context5.sent;

            if (outline) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt("return", []);

          case 5:
            output = [];
            input = outline.outlineTrees.map(tree => [null, tree]);

          case 7:
            if (!(input.length > 0)) {
              _context5.next = 18;
              break;
            }

            res = input.pop();

            if (res) {
              _context5.next = 11;
              break;
            }

            return _context5.abrupt("return", []);

          case 11:
            _res = _slicedToArray(res, 2), parent = _res[0], tree = _res[1];

            if (tree) {
              _context5.next = 14;
              break;
            }

            return _context5.abrupt("return", []);

          case 14:
            output.push({
              name: tree.representativeName,
              kind: getKind(tree),
              location: {
                uri: filePath,
                range: {
                  start: tree.startPosition,
                  end: tree.endPosition
                }
              },
              containerName: parent ? parent.representativeName : undefined
            });
            input.push(...tree.children.map(child => [tree, child]));
            _context5.next = 7;
            break;

          case 18:
            return _context5.abrupt("return", output);

          case 19:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
  }

  _getDefinitionForNamedType(query, ast, node, filePath, projectConfig) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var objectTypeDefinitions, dependencies, localObjectTypeDefinitions, typeCastedDefs, localOperationDefinationInfos, result;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return this._graphQLCache.getObjectTypeDefinitions(projectConfig);

          case 2:
            objectTypeDefinitions = _context6.sent;
            _context6.next = 5;
            return this._graphQLCache.getObjectTypeDependenciesForAST(ast, objectTypeDefinitions);

          case 5:
            dependencies = _context6.sent;
            localObjectTypeDefinitions = ast.definitions.filter(definition => definition.kind === OBJECT_TYPE_DEFINITION || definition.kind === INPUT_OBJECT_TYPE_DEFINITION || definition.kind === ENUM_TYPE_DEFINITION || definition.kind === SCALAR_TYPE_DEFINITION || definition.kind === INTERFACE_TYPE_DEFINITION);
            typeCastedDefs = localObjectTypeDefinitions;
            localOperationDefinationInfos = typeCastedDefs.map(definition => ({
              filePath,
              content: query,
              definition
            }));
            _context6.next = 11;
            return getDefinitionQueryResultForNamedType(query, node, dependencies.concat(localOperationDefinationInfos));

          case 11:
            result = _context6.sent;
            return _context6.abrupt("return", result);

          case 13:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
  }

  _getDefinitionForFragmentSpread(query, ast, node, filePath, projectConfig) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var fragmentDefinitions, dependencies, localFragDefinitions, typeCastedDefs, localFragInfos, result;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return this._graphQLCache.getFragmentDefinitions(projectConfig);

          case 2:
            fragmentDefinitions = _context7.sent;
            _context7.next = 5;
            return this._graphQLCache.getFragmentDependenciesForAST(ast, fragmentDefinitions);

          case 5:
            dependencies = _context7.sent;
            localFragDefinitions = ast.definitions.filter(definition => definition.kind === FRAGMENT_DEFINITION);
            typeCastedDefs = localFragDefinitions;
            localFragInfos = typeCastedDefs.map(definition => ({
              filePath,
              content: query,
              definition
            }));
            _context7.next = 11;
            return getDefinitionQueryResultForFragmentSpread(query, node, dependencies.concat(localFragInfos));

          case 11:
            result = _context7.sent;
            return _context7.abrupt("return", result);

          case 13:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this);
    }));
  }

  getOutline(documentText) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", getOutline(documentText));

          case 1:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
  }

}